// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 2C8.96243 2 6.5 4.46243 6.5 7.5C6.5 10.5376 8.96243 13 12 13C15.0376 13 17.5 10.5376 17.5 7.5C17.5 4.46243 15.0376 2 12 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 14C5.23858 14 3 16.2386 3 19V22H21V19C21 16.2386 18.7614 14 16 14H14.618L12 19.2361L9.38197 14H8Z"}}]};

const UserBusinessFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-business-filled',
    ref,
    icon: element,
  },
));

UserBusinessFilledIcon.displayName = 'UserBusinessFilledIcon';

export default UserBusinessFilledIcon;
